import r from "r-dom";
import { withApollo } from "../../graphql/client";
import ContentReplacementForm from "./ContentReplacementForm";

export default function (props, context) {
  return function ContentReplacementFormApp() {
    return withApollo(r(ContentReplacementForm, props));
  };
}
